"use strict";

const InitializeBannerSecondary = () => {
    const paddingDesktop = $("#banner-paddingDesktop").val();
    const paddingTablet  = $("#banner-paddingTablet").val();
    const paddingMobile  = $("#banner-paddingMobile").val();

    const handlePaddingBanner = () => {
        const windowWidth    = $(window).width();
        const $currentBanner = $("#banner-paddingDesktop").closest(".banner-secondary");
        let paddingUsed      = "";

        if (windowWidth >= 1440) {
            paddingUsed = paddingDesktop;
        } else if (windowWidth >= 544) {
            paddingUsed = paddingTablet;
        } else {
            paddingUsed = paddingMobile;

        }

        $currentBanner.css({"padding": "" + paddingUsed});
    };

    const init = () => {
        handlePaddingBanner();
        $(window).on("resize", handlePaddingBanner);
    };

    init();
};

export default InitializeBannerSecondary;
